import React, {useEffect, useState} from 'react';
import { Navbar, Nav, NavDropdown,Button, Container, NavbarBrand } from 'react-bootstrap';
// import {A} from 'hookrouter';
import {Link, useNavigate} from 'react-router-dom'
import api from './conexao';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {faBookMedical,faRightFromBracket,faUser,faBook,faPrint,faCloudArrowUp,faHospitalUser,faUserDoctor, faTablets, faFileLines} from "@fortawesome/free-solid-svg-icons"
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons"
import './menu.css'
import logoMed from '../img/medsolutions.png'
import { useGlobalNavigation } from '../contexts/GlobalNavigationContext';



function Menu () {

    let tokin = localStorage.getItem('token')  //LE O TOKEN QUE FOI GRAVADO NO LOGIN

    var payload = tokin.split('.')[1];
    var decodedPayload = JSON.parse(window.atob(payload));
    if (decodedPayload.param3 === 0) {
      var menuFichaPaciente = true;
    }
    
    const [expanded, setExpanded] = useState(false); 
    const handleToggle = () => { 
      setExpanded(!expanded) }
    const handleSelect = () => { setExpanded(false); };
    
    // Hook para proteção de navegação
    const { canNavigate } = useGlobalNavigation();
    const navigate = useNavigate();
    
    // Função para navegação protegida
    const handleProtectedNavigation = (path) => {
      if (canNavigate()) {
        navigate(path);
        handleSelect(); // Fecha o menu
      }
      // Se não pode navegar, o canNavigate() já mostrou o confirm
    };
      
    function handleLougout(){
      if (canNavigate('Você tem alterações não salvas. Deseja sair mesmo assim?')) {
        localStorage.removeItem('token')
        localStorage.removeItem('tokenRefresh')
        window.location = '/'
      }
    }
    
    return (
    <div>
       <div > 
       <div >  

       <Navbar bg="light" expand="lg" fixed="top" expanded={expanded}>
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={handleToggle}/>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto" onSelect={handleSelect}>

            <NavDropdown title="Início" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={handleSelect}><FontAwesomeIcon icon={faUser} size="lg" style={{color: '#007bff'}} /> <span /> Usuario: {decodedPayload.param2}</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/landingpage')}><FontAwesomeIcon icon={faUser} size="lg" style={{color: '#226c3fff'}} /> <span /> LandingPage</NavDropdown.Item>
              <NavDropdown.Item onClick={() => {handleLougout()}}><FontAwesomeIcon icon={faRightFromBracket} size="lg" style={{color: '#dc3545'}} /><span /> LogOff</NavDropdown.Item>
            </NavDropdown>
            
            <NavDropdown title="Cadastro" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/paciente/paciente')}><FontAwesomeIcon icon={faHospitalUser} size="lg" style={{color: '#17a2b8'}} /><span /> Paciente</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/medico/medico')}><FontAwesomeIcon icon={faUserDoctor} size="lg" style={{color: '#226c3fff'}} /><span /> Médico</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/medicamento/medicamento')}><FontAwesomeIcon icon={faTablets} size="lg" style={{color: '#ffc107'}} /><span /> Medicamento</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/texto/texto')}><FontAwesomeIcon icon={faFileLines} size="lg" style={{color: '#6f42c1'}} /><span /> Texto</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Movimento" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/agenda/agenda')}><FontAwesomeIcon icon={faBook} size="lg" style={{color: '#007bff'}} /><span /> Agenda</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/fichapaciente/fichapacienteacesso')} disabled={menuFichaPaciente}><FontAwesomeIcon icon={faBookMedical} size="lg" style={{color: '#226c3fff'}}/><span /> Ficha do Paciente</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Configurações" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/agenda/confagenda')}><FontAwesomeIcon icon={faBook} size="lg" style={{color: '#6c757d'}} /><span /> Configuração da Agenda</NavDropdown.Item>
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/whatsApp/whatsapp')}><FontAwesomeIcon icon={faWhatsapp} size="lg" style={{color: '#25d366'}} /><span /> Configuração do WhatsApp</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Relatórios" id="basic-nav-dropdown">
              <NavDropdown.Item onClick={() => handleProtectedNavigation('/relatorios/impagenda')}><FontAwesomeIcon icon={faPrint} size="lg" style={{color: '#343a40'}} /><span /> Imprimir Agenda</NavDropdown.Item>
            </NavDropdown>

            <NavDropdown title="Utilitários" id="basic-nav-dropdown">
               <NavDropdown.Item onClick={handleSelect}><FontAwesomeIcon icon={faCloudArrowUp} size="lg" style={{color: '#17a2b8'}} /> <span /> Backup </NavDropdown.Item>
            </NavDropdown>

          </Nav>
        </Navbar.Collapse>
        <Navbar.Brand className="ms-auto">
          <span onClick={() => handleProtectedNavigation('/')} style={{cursor: 'pointer'}}>
            <img src={logoMed} width="200" height="56" className="d-inline-block align-top" alt="Logo" />
          </span>
        </Navbar.Brand>
      </Container>
    </Navbar>
        
       
     </div>
     
    </div>
        
        
 
    </div>

    
    )
}


export default Menu; //retornar funcao sempre sem ()